import { significantMantissa } from '@/utils/numberFormat.js'

// Helpers for displaying ROAS/ROI figures. ROAS is always the attributed KPI
// divided by the spend that produced it, and it is always shown — including when
// the KPI and the spend are measured in different units, where the ratio simply
// carries both (e.g. "units/USD").

// The composite unit of a ROAS figure, or null when it doesn't need one: the
// units match (the ratio is dimensionless, as in the classic USD/USD case) or one
// of them is unknown. The order is outputUnit/spendUnit, matching the backend's
// own roi_unit_name convention ('USD/USD').
export function roasUnitLabel (outputUnit, spendUnit) {
  if (!outputUnit || !spendUnit) return null
  if (outputUnit === spendUnit) return null
  return outputUnit + '/' + spendUnit
}

// What to append to a formatted ROAS value: the familiar 'x' when the ratio is
// dimensionless, nothing when it isn't — a value carrying a composite unit gets
// that unit in its label instead, so it doesn't read as "2.34x units/USD".
export function roasSuffix (outputUnit, spendUnit) {
  return roasUnitLabel(outputUnit, spendUnit) === null ? 'x' : ''
}

// Decimals a ROAS value needs to keep two significant ones: two for the usual
// same-unit ratios, more for a cross-unit ratio small enough that a fixed mantissa
// would render it as '0.00'. See significantMantissa for the rule.
export function roasMantissa (value) {
  return significantMantissa(value, 2)
}
